var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "24px",
    viewBox: "0 0 34 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74251B9F-646F-453C-91B2-C9DA07AC99B5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-453.000000, -1086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(453.000000, 1086.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,20.8 C34,22.5672 32.5501429,24 30.7619048,24 L3.23809524,24 C1.44985714,24 0,22.5672 0,20.8 L0,3.2 C0,1.4328 1.44985714,0 3.23809524,0 L30.7619048,0 C32.5501429,0 34,1.4328 34,3.2 L34,20.8 Z",
    id: "Path",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86485714,8 L12.3517143,8 L8.81328571,16.7984 L6.25438095,16.7984 L6.25438095,16.8 L4.14961905,8.7056 C4.14961905,8.7056 5.93542857,8.5536 7.14566667,11.2824 C7.19909524,11.6152 7.73904762,14.2656 7.73904762,14.2656 L9.86485714,8 Z M11.8910952,16.8 L13.2672857,8 L15.6205714,8 L14.2152381,16.8 L11.8910952,16.8 Z M28.3398095,8 L30.1401905,16.8 L28.0249048,16.8 L27.7771905,15.5432 L24.8661429,15.5432 L24.3901429,16.8 L22.081381,16.8 L25.8942381,8 L28.3398095,8 Z M25.5105238,13.8624 L27.438,13.8624 L26.7758095,10.5368 L25.5105238,13.8624 Z M18.9177619,10.5648 C18.9177619,11.5152 22.1437143,11.6688 22.1437143,13.7976 C22.1437143,15.5672 19.8317143,16.7992 18.1649048,16.7992 C16.5021429,16.7992 15.641619,16.3144 15.641619,16.3144 L16.0423333,14.5416 C16.0423333,14.5416 16.930381,15.0288 18.2758095,15.0288 C19.6171905,15.0288 19.8041905,14.4904 19.8041905,14.2576 C19.8041905,12.8992 16.5830952,13.2616 16.5830952,10.6168 C16.5830952,9.1544 17.8435238,7.9992 20.2874762,7.9992 C21.3665714,7.9992 22.4659048,8.4112 22.4659048,8.4112 L22.0886667,10.2584 C22.0886667,10.2584 21.2281429,9.7192 20.4769048,9.7192 C19.3209048,9.7192 18.9177619,10.08 18.9177619,10.5648 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45733333,12.756 L6.67533333,8.9576 C6.67533333,8.9576 6.32157143,8.1344 5.40195238,8.1344 C4.48233333,8.1344 1.80766667,8.1344 1.80766667,8.1344 C1.80766667,8.1344 6.39038095,9.472 7.45733333,12.756 Z",
    id: "Path",
    fill: "#FFC107"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.17e3dbaea578ca47912367cc2f0bb272.svg";
export { ForwardRef as ReactComponent };